import { session as _session } from 'lib_ui-services';

export default {
    verb: 'doingGet',
    namespace: 'application',
    relation: 'session',
    description: 'get the current session',
    priority: 10,
    logic
};

const _p = {
    getSessionData: _session.getSessionData
};

export const _private = _p;

/**
 * @typedef {import('../../../../../types').Session} Session
 */

/**
 *
 * @returns {Promise<{result: Session[]}>}
 */
async function logic() {
    const session = await _p.getSessionData();
    return { result: [session] };
}
